const getActivitiesStatus = (state) => {
  return state.activitiesStatusSubscription.data || null;
};

const getIsActivitiesStatusLoading = (state) => {
  return state.activitiesStatusSubscription.loading;
};

export { getActivitiesStatus, getIsActivitiesStatusLoading };
